/* global axios */
import ApiClient from '../../ApiClient';

class WhatsappCallsAPI extends ApiClient {
  constructor() {
    super('whatsapp_calls', { accountScoped: true });
  }

  show(callId) {
    return axios.get(`${this.url}/${callId}`).then(r => r.data);
  }

  queueStatus() {
    return axios.get(`${this.url}/queue_status`).then(r => r.data);
  }

  initiate(conversationId, sdpOffer) {
    return axios
      .post(`${this.url}/initiate`, {
        conversation_id: conversationId,
        sdp_offer: sdpOffer,
      })
      .then(r => r.data);
  }

  requestPermission(conversationId) {
    return axios
      .post(`${this.url}/request_permission`, {
        conversation_id: conversationId,
      })
      .then(r => r.data);
  }

  permissionStatus(conversationId) {
    return axios
      .get(`${this.url}/permission_status`, {
        params: { conversation_id: conversationId },
      })
      .then(r => r.data);
  }

  accept(callId, sdpAnswer, routingToken) {
    return axios
      .post(`${this.url}/${callId}/accept`, {
        sdp_answer: sdpAnswer,
        routing_token: routingToken,
      })
      .then(r => r.data);
  }

  joinIncomingBridge(callId, sdpOffer, routingToken) {
    return axios
      .post(`${this.url}/${callId}/join_incoming_bridge`, {
        sdp_offer: sdpOffer,
        routing_token: routingToken,
      })
      .then(r => r.data);
  }

  abandonIncomingBridge(callId, routingToken) {
    return axios
      .post(`${this.url}/${callId}/abandon_incoming_bridge`, {
        routing_token: routingToken,
      })
      .then(r => r.data);
  }

  reject(callId) {
    return axios.post(`${this.url}/${callId}/reject`).then(r => r.data);
  }

  joinHandoff(callId, sdpOffer, routingToken) {
    return axios
      .post(`${this.url}/${callId}/join_handoff`, {
        sdp_offer: sdpOffer,
        routing_token: routingToken,
      })
      .then(r => r.data);
  }

  confirmHandoff(callId, routingToken) {
    return axios
      .post(`${this.url}/${callId}/confirm_handoff`, {
        routing_token: routingToken,
      })
      .then(r => r.data);
  }

  declineHandoff(callId, routingToken) {
    return axios
      .post(`${this.url}/${callId}/decline_handoff`, {
        routing_token: routingToken,
      })
      .then(r => r.data);
  }

  terminate(callId) {
    return axios.post(`${this.url}/${callId}/terminate`).then(r => r.data);
  }

  rerouteHandoff(callId, targetType, targetId) {
    return axios
      .post(`${this.url}/${callId}/reroute_handoff`, {
        target_type: targetType,
        target_id: targetId,
      })
      .then(r => r.data);
  }

  transferHandoff(callId, targetType, targetId, customerRequestedTransfer) {
    return axios
      .post(`${this.url}/${callId}/transfer_handoff`, {
        target_type: targetType,
        target_id: targetId,
        customer_requested_transfer: customerRequestedTransfer,
      })
      .then(r => r.data);
  }

  reportQualityMetrics(callId, sample) {
    return axios
      .post(`${this.url}/${callId}/quality_metrics`, { sample })
      .then(r => r.data);
  }

  uploadRecording(callId, blob, filename = 'call-recording.webm') {
    const formData = new FormData();
    formData.append('recording', blob, filename);
    return axios
      .post(`${this.url}/${callId}/upload_recording`, formData)
      .then(r => r.data);
  }
}

export default new WhatsappCallsAPI();
